import apiClient from "./client";

export const notificationServices = {
  getNotifications: () => apiClient.get("/notifications/all"),
};
